// extracted by css-extract-rspack-plugin
export default {"cls1":"News-cls1_DCD","cls2":"News-cls2_kQT News-cls1_DCD"};